import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { StringFormattingService } from '../../../services';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class UserOnlineService extends AutomationDisplayService {
  constructor(
    protected readonly formatter: StringFormattingService,
    protected readonly translateService: TranslateService,
    protected readonly sanitizer: DomSanitizer,
  ) {
    super();
  }

  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.USER_ONLINE.WHEN_ACTION', {
        businessAppName: this.translateService.instant('COMMON.BUSINESS_APP'),
      }),
      this.noValidationErrorsDetected(),
    );
  }

  getActivityColumn(_namespace: string, _activity: ActivityInterface): ActivityTableEntry {
    return this.triggerActivityEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.USER_ONLINE.USER_ONLINE', {
        businessAppName: this.translateService.instant('COMMON.BUSINESS_APP'),
      }),
    );
  }
}
